<template>
<div class="chapter">
<div class="inner_page">
<a id="page_5"></a>
<h2 class="partnum" id="pt1">Part 1</h2>
<h2 class="parttitle">The Case Studies</h2>
<a id="page_6"></a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 08_Part01.vue?7a705cca